module.exports = __webpack_public_path__ + "static/img/shebao.fdac16b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data_cate_icon/shebao.png
// module id = EdJN
// module chunks = 5